var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpiredTag = function SvgExpiredTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}.c{fill:none;stroke:#171926;stroke-width:1.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 13,
    height: 13,
    transform: "translate(-0.027 -0.027)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "",
    transform: "translate(0.027 0.027)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.285 1.285)"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#171926",
    strokeWidth: "1.5px",
    fill: "none",
    cx: 5.188,
    cy: 5.188,
    r: 5.188
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#171926",
    strokeWidth: "1.5px",
    fill: "none",
    d: "M-23499-22410v3.373h2.889",
    transform: "translate(23503.951 22412.063)"
  })))));
};
export default SvgExpiredTag;